import { AccountReceivableInstallment } from '@/core/domain/financial/AccountReceivable/AccountReceivable.types';
import { useDocumentTypeMutation } from '@/core/domain/enterprise/DocumentTypes/DocumentTypes.hooks';
import { MathRound } from '@/utils/functions/MathRound';
import { DocumentType } from '@/core/domain/enterprise/DocumentTypes/DocumentTypes.types';
import { useQueryClient } from 'react-query';

interface PropsInstallment {
  installmentValue: number;
  discountIncrease: number;
  installmentReceivables?: AccountReceivableInstallment[];
  currentInstallment: number;
  documentTypeId?: number;
}

const useGetInstallmentRate = () => {
  const { mutateAsync: documentTypeMutate } = useDocumentTypeMutation();
  const query = useQueryClient()
    .getMutationCache()
    .find({ mutationKey: 'documentType' });

  return async (params: PropsInstallment) => {
    let tariff;

    let documentType: DocumentType | undefined;
    const queryDocumentType = query?.state.data as DocumentType | undefined;

    if (params.documentTypeId) {
      if (queryDocumentType && queryDocumentType.id === params.documentTypeId) {
        documentType = query?.state.data as DocumentType;
      } else {
        const newMutation = await documentTypeMutate(params.documentTypeId);
        query?.setState({
          ...query.state,
          data: await newMutation,
        });
        documentType = newMutation;
      }
    }

    if (documentType) {
      // Retorna a quantidade de parcela que tem o mesmo tipo de documento de params
      const filteredDocumentTypeIndex = params.installmentReceivables?.filter(
        ({ documentTypeId }) => documentTypeId === params.documentTypeId,
      )?.length;

      const index = filteredDocumentTypeIndex
        ? filteredDocumentTypeIndex -
          (params.installmentReceivables?.at(params.currentInstallment)
            ?.documentTypeId === params.documentTypeId
            ? 1
            : 0)
        : 0;

      if (documentType.fixedRate) {
        tariff = MathRound(
          (documentType.percentRate / 100) *
            (params.installmentValue + (params.discountIncrease ?? 0)),
          2,
        );
      } else if (documentType.rates.length) {
        if (typeof index === 'number') {
          const rate = documentType.rates[index];

          if (rate) {
            tariff =
              (rate?.percentRate / 100) *
              (params.installmentValue + (params.discountIncrease ?? 0));
          } else {
            const lastIndex = documentType.rates.length - 1;

            tariff =
              (documentType.rates[lastIndex]?.percentRate / 100) *
              (params.installmentValue + (params.discountIncrease ?? 0));
          }
        }
      }
    }

    return tariff || 0;
  };
};

export default useGetInstallmentRate;
